import React from 'react';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children }) => {
  const userId = localStorage.getItem('id');

  // If user is already logged in, redirect to dashboard
  if (userId) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

export default PublicRoute;

